module.exports = __webpack_public_path__ + "img/proyecto6.b7eaa8a0.png";